module.exports = function() {
  return new Worker(__webpack_public_path__ + "dataParse.worker.ee2c2440.worker.js");
};